var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForDeliverySupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9722 14C23.7722 14 23.5722 14.1 23.3722 14.2L15.4722 18.6C15.1722 18.8 14.9722 19.1 14.9722 19.5V28.5C14.9722 28.9 15.1722 29.2 15.4722 29.4L23.3722 33.8C23.5722 33.9 23.7722 34 23.9722 34C24.1722 34 24.3722 33.9 24.5722 33.8L25.4722 33.3C25.1722 32.7 25.0722 32 24.9722 31.3V24.6L30.9722 21.2V25C31.6722 25 32.3722 25.1 32.9722 25.3V19.5C32.9722 19.1 32.7722 18.8 32.4722 18.6L24.5722 14.2C24.3722 14.1 24.1722 14 23.9722 14ZM23.9722 16.2L29.9722 19.5L27.9722 20.6L22.0722 17.2L23.9722 16.2ZM20.0722 18.3L25.9722 21.8L23.9722 22.9L17.9722 19.5L20.0722 18.3ZM16.9722 21.2L22.9722 24.6V31.3L16.9722 27.9V21.2ZM33.2722 27.8L29.6722 31.4L28.0722 29.8L26.9722 31L29.7722 34L34.5722 29.2L33.2722 27.8Z",
    fill: "#ED6C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForDeliverySupplyReqIcon);
export default __webpack_public_path__ + "static/media/for-delivery-supply-req-icon.fece734e773d1537521bd24015051b14.svg";
export { ForwardRef as ReactComponent };